import React from 'react';
import { Col, Row, Collapse } from 'antd';
import { formatCurrency } from '../../../utils/utils';

const Settlements = ({ settlements, t }) => {
  return (
    <>
      <Col xs={0} xl={24}>
        <Row>
          <Col className="info-section-title">
            <p className="text-18-bold">{t('Settlements.header')}</p>
          </Col>
          <Col className=" mt-30 info-section-title">
            <p className="text-16-bold">{t('Settlements.interestFreeCreditCard')}</p>
          </Col>
          <Col className="text-dark-small">
            {settlements.interestFree.map((interestFree, i) => {
              return (
                <div key={i.toString()}>
                  <Row gutter={20} type="flex" justify="start">
                    <Col>
                      {interestFree.months} {t('Settlements.settlements')}
                    </Col>
                    <Col>{interestFree.info}</Col>
                    <Col>
                      {formatCurrency(interestFree.amount)} {t('Settlements.month')}
                    </Col>
                  </Row>
                </div>
              );
            })}
          </Col>
          <Col className="info-section-title mt-10">
            <p className="text-16-bold">{t('Settlements.interestCreditCard')}</p>
          </Col>
          <Col className="text-dark-small">
            {settlements.interest.map((interest, i) => {
              return (
                <div key={i.toString()}>
                  <Row gutter={20} type="flex" justify="start">
                    <Col>
                      {interest.months} {t('Settlements.settlements')}
                    </Col>
                    <Col>{t('Settlements.interest')}</Col>
                    <Col>
                      {formatCurrency(interest.amount)} {t('Settlements.month')}
                    </Col>
                  </Row>
                </div>
              );
            })}
          </Col>
          <Col className="mt-40 settlements-helper italic">{t('Settlements.helper')}</Col>
        </Row>
      </Col>
      <Col xs={24} xl={0}>
        <div>
          <Collapse className="product-collapse">
            <Collapse.Panel
              header={<p className="text-14-normal">{t('Settlements.header')}</p>}
              key="1"
            >
              <Row>
                <Col className=" mt-30 info-section-title">
                  <p className="text-16-bold">
                    {t('Settlements.interestFreeCreditCard')}
                  </p>
                </Col>
                <Col className="text-dark-small">
                  {settlements.interestFree.map((interestFree, i) => {
                    return (
                      <div key={i.toString()}>
                        <Row gutter={20} type="flex" justify="start">
                          <Col>
                            {interestFree.months} {t('Settlements.settlements')}
                          </Col>
                          <Col>{interestFree.info}</Col>
                          <Col>
                            {formatCurrency(interestFree.amount)} {t('Settlements.month')}
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                </Col>
                <Col className="info-section-title mt-10">
                  <p className="text-16-bold">{t('Settlements.interestCreditCard')}</p>
                </Col>
                <Col className="text-dark-small">
                  {settlements.interest.map((interest, i) => {
                    return (
                      <div key={i.toString()}>
                        <Row gutter={20} type="flex" justify="start">
                          <Col>
                            {interest.months} {t('Settlements.settlements')}
                          </Col>
                          <Col>{t('Settlements.interest')}</Col>
                          <Col>
                            {formatCurrency(interest.amount)} {t('Settlements.month')}
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                </Col>
                <Col className="mt-40 settlements-helper italic">
                  {t('Settlements.helper')}
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        </div>
      </Col>
    </>
  );
};

export default Settlements;
